import React from 'react'
import Skeleton from 'react-loading-skeleton'
import styles from './track.module.scss'

const TimeTrackSkeleton: React.FC = () => {
  return (
    <div className={styles.days} style={{ opacity: 0.5 }}>
      {[0, 1].map((day) => (
        <section className={styles.day} key={day}>
          <header className={styles.dayHeader}>
            <Skeleton width={160} />
          </header>
          <ul className={styles.entries}>
            {[0, 1].map((entry) => (
              <li className={styles.entry} key={entry}>
                <div className={styles.entryTop}>
                  <Skeleton width={100} />
                  <Skeleton width={30} />
                </div>
                <Skeleton />
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  )
}

export default TimeTrackSkeleton
